const AppConfig = {
  Rules : {
    PasswordLength: 6,
    MFALength: 6,
    MaxKycImageSize: 4194304,
  },
  ROLE_MANAGER: ['manage'],
  DEFAULT_ROLES: ['export'],
  CUSTOMER_MARKETING_STATUS: {
    ChuaGui: 0,
    ChuaGuiText: 'Chờ gửi',
    DaGui: 1,
    DaGuiText: 'Đã gửi',
    DaNhan: 2,
    DaNhanText: 'Đã nhận',
    HoanThanh: 10,
    HoanThanhText: 'Hoàn thành',
  },
  CUSTOMER_MARKETING_RECEIVED_DSTATUS: {
    DaNhan: 1,
    DaNhanText: 'Đã nhận',
    DaDuyet: 10,
    DaDuyetText: 'Đã duyệt',
    HoanThanh: 99,
    HoanThanhText: 'Đã hủy',
  },
  ORDER_MARKETING_STATUS: {
    HoanThanhNhap: 1,
    HoanThanhNhapText: 'Chờ gửi',
    DangXuLy: 2,
    DangXuLyText: 'Đã gửi',
    HoanThanh: 10,
    HoanThanhText: 'Hoàn thành',
    Huy: 99,
    HuyText: 'Huỷ',
  },
  ORDER_STATUS: {
    Nhap: 0,
    NhapText: 'Đang nhập',
    HoanThanhNhap: 1,
    HoanThanhNhapText: 'Chờ xử lý',
    DangXuLy: 2,
    DangXuLyText: 'Đang xử lý',
    HoanThanh: 10,
    HoanThanhText: 'Hoàn thành',
    Huy: 99,
    HuyText: 'Huỷ',
  },
  KHACHHANG_MOI : 0,
  KHACHHANG_DANGHOATDONG: 1,
  KHACHHANG_DAHUY: 10,
  TIMEOUT_LOAD_HEADER_INFO: 60000, // 60s
  CANH_BAO_SO_LUONG: 500, //Cảnh báo số lượng tồn kho
  SETTINGKEYS: {
    IsKhoaDatDon:'KhoaDatDon',
    HeSoCk:'HeSoCk',
    LogoDonVi:'LogoDonVi',
    ShowDiemTichLuy:'ShowDiemTichLuy',
    GiaDanhMuc:'GiaDanhMuc',
    OrderExcelMarginLeft:'OrderExcelMarginLeft',
    OrderExcelMarginRight:'OrderExcelMarginRight',
    OrderExcelMarginTop:'OrderExcelMarginTop',
    ShowCkPercent:'ShowCkPercent',
    GoogleMapsApiKey:'GoogleMapsApiKey',
    LimitNumberOfUser: 'LimitNumberOfUser',
    ListDiscountOrder: 'ListChietKhau',
    GoogleMapsApiKey:'GoogleMapsApiKey',
    KhoaTichDiem: 'KhoaTichDiem'
  }
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/config/app.js